import "./style.scss";
import { FC } from "react";
import { AOPMaltaCertificateData } from "@/src/types/admissionOffice";
import backForDocEmpty from "@/src/assets/admissionOfficePage/back-for-doc-empty.png";
import backForDocCertificate from "@/src/assets/admissionOfficePage/back-for-doc-certificate.png";
import backForDocAuthorizationLetter from "@/src/assets/admissionOfficePage/back-for-doc-authorization-letter.png";
import type { CertificateBasicCountry } from "../certificateBasicRegistry";

interface AOPPrevProps {
  country: CertificateBasicCountry;
  bodyForPrev: AOPMaltaCertificateData;
  certificateInfo: string;
}

const AOPPrev: FC<AOPPrevProps> = ({ country, bodyForPrev, certificateInfo }) => {
  if (certificateInfo === "Certificate") {
    return (
      <div className="admission-office-prev-wrapper certificate">
        <div className={`admission-office-prev ${country} certificate`}>
          <img className="admission-office-prev-background" src={backForDocCertificate} alt="" />
          <div className="admission-office-prev-section date-and-series">
            <div className="admission-office-prev-section-date">
              <span>{bodyForPrev.currentDate ? bodyForPrev.currentDate : ""}</span>
            </div>
            <div className="admission-office-prev-section-series">
              <span>N00 00-00/000</span>
            </div>
          </div>
          <div className="admission-office-prev-section full-name">
            <p>{bodyForPrev.fullName ? bodyForPrev.fullName : ""}</p>
          </div>
          {bodyForPrev.body ? (
            <div className="admission-office-prev-section body-content">
              {bodyForPrev.body.map((item, idx) => (
                <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
              ))}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  if (certificateInfo === "Authorization Letter") {
    return (
      <div className="admission-office-prev-wrapper authorization-letter">
        <div className={`admission-office-prev ${country} authorization-letter`}>
          <img className="admission-office-prev-background" src={backForDocAuthorizationLetter} alt="" />
          <div className="admission-office-prev-section date-and-series">
            <span>N00 00-00/000</span> / <span>{bodyForPrev.currentDate ? bodyForPrev.currentDate : ""}</span>
          </div>
          <div className="admission-office-prev-section full-name">
            <p>{bodyForPrev.fullName ? bodyForPrev.fullName : ""}</p>
          </div>
          {bodyForPrev.body ? (
            <div className="admission-office-prev-section body-content">
              {bodyForPrev.body.map((item, idx) => (
                <div key={idx} dangerouslySetInnerHTML={{ __html: item }} />
              ))}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="admission-office-prev-wrapper">
      <div className={`admission-office-prev ${country}`}>
        <img className="admission-office-prev-background" src={backForDocEmpty} alt="" />
      </div>
    </div>
  );
};

export default AOPPrev;
